<template>
  <component
    :is="isCarousel ? Swiper : 'div'"
    v-bind="isCarousel ? swiperOptions : {}"
    :class="
      bem({
        layout: block.layout,
        items: block.cards.length,
      })
    "
    @resize="isCarousel ? handleResizeReset : null"
  >
    <Component
      :is="isCarousel ? SwiperSlide : 'div'"
      v-for="(item, index) in block.cards"
      :key="item.id"
      :class="
        bem('item', {
          width: item.width,
        })
      "
    >
      <UniversalCard
        :item="item"
        :aspect-ratio="block.aspectRatio"
        @clicked="handleLinkClick(item, index)"
      />
    </Component>
  </component>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination } from 'swiper/modules'

const bem = useBEM('MarketingRow')

const { isSmBreakpointOrAbove } = useBreakpoint()

const { $track } = useNuxtApp()

const props = defineProps({
  block: { type: Object, required: true },
  rowPosition: { type: Number, default: 0 },
})

const isCarousel = computed(() => props.block.layout === 'carousel')

const modules = [Pagination]

const swiperOptions = ref({
  modules: modules,
  slidesPerView: 1,
  spaceBetween: 40,
  speed: 300,
  loop: true,
  observer: true,
  pagination: {
    enabled: true,
    bulletActiveClass: 'MarketingRow__swiper-bullet--is-active',
    bulletClass: 'MarketingRow__swiper-bullet',
    horizontalClass: 'MarketingRow__swiper-pagination',
  },
  breakpoints: {
    1: {
      slidesPerView: 1,
      spaceBetween: 12,
    },
    401: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    800: {
      enabled: false,
      spaceBetween: 24,
      slidesPerView: props.block.cards.length,
      spaceBetween: 12,
      pagination: {
        enabled: false,
      }
    }
  }
})

function handleResizeReset(swiper) {
  if (isSmBreakpointOrAbove.value) {
    swiper.slideToLoop(0, 0, false)
  }
}

async function handleLinkClick(item, index) {
  await $track.global.linkClicked(
    {
      linkText: item.linkText,
      interactionElement: item.trackingId,
      interactionSection: props.block.parentTrackingId,
      interactionCategory: 'Marketing Row',
      position: index + 1,
    },
    'Clicked Marketing Row Item'
  )
}
</script>

<style lang="postcss">
.MarketingRow {
  @apply grid global-wrapper overflow-y-visible overflow-x-clip;
}

.MarketingRow--layout-stack {
  @apply grid gap-xxs xl:gap-sm;

  @screen xxs {
    @apply grid-cols-1;

    &.MarketingRow--items-4 {
      @apply grid-cols-2;
    }

    &.MarketingRow--items-2 {
      @apply grid-cols-2;
    }
  }

  @screen xl {
    &.MarketingRow--items-4 {
      @apply grid-cols-4;
    }
  }
}

.MarketingRow__swiper-pagination {
  @apply flex items-center justify-center gap-0
  -bottom-4 left-[var(--outer-gutter)] right-[var(--outer-gutter)] z-[10]
  rounded overflow-clip bg-grey-300;
  width: auto;
}

.MarketingRow__swiper-bullet {
  @apply block w-[25%] h-0.5;

  &--is-active {
    @apply bg-grey-dark rounded;
  }
}
</style>
